import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useEnterSubmit } from './common'
import { Button } from '../ui/button'
import { Lock, Mail, User } from 'lucide-react'
import { AuthCard, AuthTextInput } from './auth_card'
import { Callout } from '../ui/callout'

export const RegisterForm = ({ onSubmit, loading, coupon = null }) => {
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [passwordConfirm, setPasswordConfirm] = useState('')

    const submit = () => {
        if (onSubmit) {
            onSubmit({
                name,
                email,
                password,
                passwordConfirm,
            })
        }
    }

    const onEnter = useEnterSubmit(submit)
    return (
        <AuthCard
            title="Create your account"
            subtitle={
                <>
                    Already have an account?{' '}
                    <Link className="font-medium text-gray-600 hover:text-[#2d72d2]" to="/login">
                        Log in
                    </Link>
                </>
            }
        >
            {coupon && (
                <Callout intent="success" title="You are eligible for a discount!">
                    Coupon: {coupon.name}
                </Callout>
            )}

            <AuthTextInput
                value={name}
                type="text"
                placeholder="Name"
                disabled={loading}
                onChange={setName}
                icon={<User />}
                name="name"
            />

            <AuthTextInput
                value={email}
                placeholder="Email address"
                disabled={loading}
                onChange={setEmail}
                icon={<Mail />}
                name="email"
                type="email"
            />

            <AuthTextInput
                value={password}
                placeholder="Password"
                disabled={loading}
                onChange={setPassword}
                icon={<Lock />}
                name="password"
                type="password"
            />

            <AuthTextInput
                value={passwordConfirm}
                placeholder="Confirm password"
                disabled={loading}
                onChange={setPasswordConfirm}
                name="passwordConfirm"
                icon={<Lock />}
                onKeyDown={onEnter}
                type="password"
            />

            <div>
                <Button
                    loading={loading}
                    onClick={submit}
                    intent="primary"
                    type="submit"
                    text="Register"
                    fill
                    className="h-[37px]"
                />
            </div>
        </AuthCard>
    )
}
